import { createContext } from "react";
import { IRoute } from "../../routes/routes";
import { RouteHistoryContextType } from "./RouteHistoryContextTypes";


export const RouteHistoryContext = createContext<[RouteHistoryContextType, () => void]>([new Array<IRoute>(), () => { }]);
